import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';

const DoctorVerification = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const status = user?.doctorVerificationStatus || 'PENDING';

  const title =
    status === 'APPROVED'
      ? 'Your account is approved'
      : status === 'REJECTED'
        ? 'Your account was rejected'
        : 'Your account is pending approval';

  const description =
    status === 'APPROVED'
      ? 'You can now access doctor features.'
      : status === 'REJECTED'
        ? 'An administrator rejected your verification. Please contact support or register again with correct credentials.'
        : 'An administrator must verify your medical license before you can access doctor features.';

  const handleContinue = () => {
    const fallback = '/doctor-dashboard';
    const target = location.state?.from?.pathname || fallback;
    navigate(target);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fcfdfe] px-4">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-premium border border-outline-variant/10 p-6">
        <h1 className="text-2xl font-bold text-surface-900">{title}</h1>
        <p className="mt-2 text-surface-600">{description}</p>

        <div className="mt-5 rounded-xl border border-outline-variant/20 bg-surface-50 p-4">
          <div className="text-sm text-surface-700">
            <span className="font-semibold">Status:</span> {status}
          </div>
          {user?.licenseNumber ? (
            <div className="mt-1 text-sm text-surface-700">
              <span className="font-semibold">License:</span> {user.licenseNumber}
            </div>
          ) : null}
        </div>

        <div className="mt-6 flex gap-3 justify-end">
          <button
            type="button"
            onClick={handleLogout}
            className="px-4 py-2 rounded-full border border-outline-variant/20 text-surface-700 hover:bg-surface-50 transition-colors"
          >
            Logout
          </button>

          {status === 'APPROVED' ? (
            <button
              type="button"
              onClick={handleContinue}
              className="px-4 py-2 rounded-full bg-gradient-to-r from-primary to-primary-container text-white hover:shadow-elevated transition-all"
            >
              Continue
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DoctorVerification;
